<template>
  <vx-card v-if="showWindow" no-shadow>
    <vs-popup classContent="popup-example" title="Source of funds" :active.sync="popupFlowSelection">
        <div class="vx-row mb-12">
          <div class="vx-col w-full">
            <vs-button @click="selectExistingBankStatment()" color="primary" type="border">Attach existing bank statement </vs-button>
          </div>
        </div>
        <div class="vx-row mb-12">
          <div class="vx-col w-full">
            <vs-button @click="showUploadFiles()" color="success" type="border">Upload new doc</vs-button>
          </div>
        </div>        
    </vs-popup>
    <vs-popup classContent="popup-example" title="Source of funds" :active.sync="popUpExistingBankStatment">
      <div class="vx-row mb-12">
        <div class="vx-row mb-6">
          <div class="vx-col w-full">          
            <vs-select
                placeholder="Select bank statment"
                autocomplete
                class="selectExample  w-full"
                label="Incoming account"
                v-model="params.doc_id"
                >
                <vs-select-item :key="index" :value="item.doc_id" :text="item.doc_details" v-for="(item,index) in bankStatments" />
            </vs-select>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-button @click="uploadBankStatment()" color="primary" type="filled">Save</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>    
    <vs-popup classContent="popup-example" title="Source of funds" :active.sync="popupUploadFile">
    <div class="vx-row mb-12">
        <div class="vx-col w-full">
          <vue-dropzone ref="myVueDropzone" id="dropzone" multiple :options="dropzoneOptions" v-on:vdropzone-sending="sendingEvent" v-on:vdropzone-complete="successUpload"></vue-dropzone>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-button @click="uploadFile()" color="primary" type="filled">Upload</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Source of funds" :active.sync="popupSof">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Salary
          <v-select :closeOnSelect="true" v-model="params.salary" label="name" :options="salary" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Amount" v-model="params.amount" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Currency
          <v-select :closeOnSelect="true" v-model="params.currency" label="code" :options="bizCurrency" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          Entry date
              <flat-pickr :config="configFromdateTimePicker" v-model="params.entry_date" placeholder="Select date" @on-change="onFromChange" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">          
          <vs-select
              placeholder="Select account"
              autocomplete
              class="selectExample  w-full"
              label="Incoming account"
              v-model="params.incoming"
              >
              <vs-select-item :key="index" :value="item.account_number" :text="item.bank_details" v-for="(item,index) in inAccounts" />
          </vs-select>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-select
              placeholder="Select account"
              autocomplete
              class="selectExample  w-full"
              label="Outgoing account"
              v-model="params.outgoing"
              >
              <vs-select-item :key="index" :value="item.account_number" :text="item.bank_details" v-for="(item,index) in outAccounts" />
          </vs-select>         
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" label="Explanation" v-model="params.explanation" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="sendData('sof')" color="primary" type="filled">Save</vs-button>
        </div>
      </div>
    </vs-popup>
    
    <vx-card no-shadow>
    <vs-table max-items="5" pagination :data="tableData">
            <template slot="thead">
                <vs-th v-for="(item,index) in fieldsHead" :key="index">{{item}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                   <vs-td  v-for="(item,index) in fieldsHead" :key="index" :data="data[indextr][item]">
                        {{data[indextr][item]}}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
  </vx-card>
    
    <div class="vx-row mb-4">
        <div class="vx-col w-1/4">
          <vs-button label="button" @click="popupSof=true" class="ml-auto w-full">Source of funds</vs-button>
        </div>
      </div>
      <table-view 
      :end-point="endPoint"
      :column-defs="columnDefs"
      :line-details="params"
      :filters="filters"
      :call-params="callParams"
      :call-url="'/api/client'"
      :pop-ups="popUps"
      >
    </table-view>
  </vx-card>
</template>

<script>
import axios from "@/axios.js"
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import bizCurrency from '../../../resources/biz_get_currencies.json';
import salary from '../../../resources/salary.json';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import tableView from '../../components/tableView';

export default {
  data() {
    const params = new URLSearchParams();
    params.append('type', 'get-risk-table');
    params.append('email', this.$route.params.email);
    return {
      columnDefs: [
        {
          headerName: 'id',
          field: 'id',
          filter: true,
          width: 150
        },
        {
          headerName: 'level',
          field: 'level',
          filter: true,
          width: 150
        },
        {
          headerName: 'otp_id',
          field: 'otp_id',
          filter: true,
          width: 150
        },
        {
          headerName: 'process',
          field: 'process',
          filter: true,
          width: 150
        },
        {
          headerName: 'req_name',
          field: 'req_name',
          filter: true,
          width: 150
        },
        {
          headerName: 'otp_status',
          field: 'otp_status',
          filter: true,
          width: 150
        },
        {
          headerName: 'risk_group',
          field: 'risk_group',
          filter: true,
          width: 150
        },
        {
          headerName: 'last_updated',
          field: 'last_updated',
          filter: true,
          width: 150
        }
      ],
      popUps:{},
      filters: {disable:true},
      tableView,
      endPoint:'clientDocs',
      callParams: params,
      tableData:[],
      fieldsHead: [],
      popupSof: false,
      popupUploadFile: false,
      popupFlowSelection: false,
      popUpExistingBankStatment: false,
      showCurrency: false,
      inAccounts: [],
      outAccounts: [],
      bankStatments: [],
      bizCurrency:bizCurrency,
      salary: salary,
      sof_id:0,
      params: {incoming:'',outgoing:'',doc_id:''},
      configFromdateTimePicker: {
        minDate: null,
        maxDate: null
      },
      configTodateTimePicker: {
        minDate: null
      },
      dropzoneOptions: {
          url: '/api/client',
          thumbnailWidth: 150,
          maxFilesize: 100,
          paramName: 'document',
          withCredentials: true,
          //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          autoProcessQueue: false
      },
      successStatuses:['cl doc path inserted','password reset success!','waiting for user to reset!','waiting for user to verify!','updated new client details!','Doc Status Updated!','method approved!','payment method status updated!','bk checkpoint updated!','verification status updated!','just retroed that tran!','inserted note!']
    }
  },
  components:{
    'v-select': vSelect,
    flatPickr,
    'vue-dropzone': vue2Dropzone,
    tableView
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    showWindow(){
      if(this.$route.path.indexOf('/clients/')!==-1){
        //if(this.fieldsData.length===0)
          this.setData();
        return true;
      } else if(this.sof_id!==0){
        this.resetSof();
      }
      return false;
    },
  },
  methods:{
    uploadBankStatment: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', 'existing-bank-statment');
      params.append('email', this.$route.params.email); 
      params.append('doc_id', this.doc_id);
      params.append('sof_id', this.sof_id);      
      axios.post("/api/client",params)
      .then(() => {
        that.popUpExistingBankStatment = false;
        that.resetSof();
        that.setData();
      })
      .catch(() => { })
    },    
    resetSof: function(){
      this.sof_id = 0;
    },
    uploadFile: function(){
      this.$refs.myVueDropzone.processQueue();
    },
    sendingEvent (file, xhr, formData) {
        formData.append('type', 'file-upload');
        formData.append('email', this.$route.params.email);
        formData.append('sof_id',this.sof_id);
        formData.append('get_doc_names-search','SOF');        
    },
    setData: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', 'get-risk');
      params.append('email', this.$route.params.email);      
      axios.post("/api/client",params)
      .then((response) => {
        that.tableData.splice(0);
        for(let i in response.data.Data){
          let data = JSON.parse(response.data.Data[i].object);
          if(that.fieldsHead.length===0){
              for(let i in data){
                  that.fieldsHead.push(i);
              }
          }
          that.tableData.push(data);
        }
        that.inAccounts.splice(0);        
        for(let i in response.data.InAccounts){
          let obj =  JSON.parse(response.data.InAccounts[i].object);          
          that.inAccounts.push(obj);
        }
        that.outAccounts.splice(0);
        for(let i in response.data.OutAccounts){
          let obj =  JSON.parse(response.data.OutAccounts[i].object);
          that.outAccounts.push(obj);
        }
      })
      .catch(() => { })
    },
    onFromChange(selectedDates, dateStr) {
      this.$set(this.configTodateTimePicker, 'minDate', dateStr);
    },
    openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
    sendData: function(type){
      this.sof_id = 665
      this.popupFlowSelection = true;
      this.type= type;
      
      let that = this;
      const params = new URLSearchParams();
      params.append('type', type);
      params.append('email', this.$route.params.email);
      switch(type){
        case 'sof':{
          params.append('salary', this.params.salary.name);
          params.append('amount', this.params.amount);
          params.append('currency', this.params.currency.code);
          params.append('entry_date', this.params.entry_date);
          params.append('incoming', this.params.incoming);
          params.append('outgoing', this.params.outgoing);
          params.append('explanation', this.params.explanation);        
          break;
        }        
      }
      this.$vs.loading();     
      axios.post("/api/client",params)
      .then((data) => {
        that.$vs.loading.close();
        if(data.data.result==='fail'){
          that.openAlert('danger','Failed',data.data.result);          
        } else{
          that.sof_id = 0;
          that.$refs.myVueDropzone.removeAllFiles();
          that.reset();
          that.sof_id = data.data.sof_id;  
          that.popupFlowSelection = true;        
        }
      })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    selectExistingBankStatment: function(){
      let that = this;
      const params = new URLSearchParams();
      params.append('type', 'get-bank-statments');
      params.append('sof_id', this.sof_id);
      params.append('email', this.$route.params.email);
      this.$vs.loading();
      axios.post("/api/client",params)
      .then((response) => {
        that.$vs.loading.close();
        if(response.data.result==='fail'){
          that.openAlert('danger','Failed',response.data.result);          
        } else{
          that.bankStatments.splice(0);
          for(let i in response.data){
            let obj =  JSON.parse(response.data[i].object);
            that.bankStatments.push(obj);
          }          
          that.popupFlowSelection = false;
          that.popUpExistingBankStatment = true;       
        }
      })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    showUploadFiles: function(){
      this.popupFlowSelection = false;
      this.popupUploadFile = true;
    },
    reset: function(){
      this.popupSof = false;
      this.popupUploadFile = false;
      this.params = {};
    },
    successUpload(response) {
        let res = JSON.parse(response.xhr.response);
        if(res[0].out1==='done!' || this.successStatuses.indexOf(res[0].out1)!==-1){
          this.$vs.notify({ color: 'success', title: 'Upload Success', text: 'File uploaded' })
          this.reset();
        } else
          this.$vs.notify({ color: 'danger', title: 'Failed', text: res[0].out1 })
    },
    showError(){
    }
  }
}
</script>